<template>
	<el-container class="loginContainer">
		<div class="whole-div SID0001_LoginDiv">
			<div class="divLogin">
				<el-header>
					<img
						src="../../assets/image/logo.png"
						alt="LOGO"
						width="150"
						height="89"/>
				</el-header>
				<!-- 2021/02/06 #10499 START -->
				<!-- <span class="span-title">LOGIN</span> -->
				<span class="span-title"></span>
				<!-- 2021/02/06 #10499 END -->
					<el-alert v-if="this.getElAdminAlert != null && this.getElAdminAlert.trim() != '' "
						:title="this.getElAdminAlert"
						type="error"
						effect="dark"
						:closable="false">
					</el-alert>
				<el-main>
					<el-form
						:model="LoginForm"
						:rules="rules"
						ref="LoginForm"
						label-width="auto"
						class="demo-ruleForm "
						@submit.prevent.native="submitLoginForm('LoginForm')">
						<el-form-item prop="contract" label="企業コード">
							<el-input
								class="inputClass"
								v-model="LoginForm.contract"
								placeholder="企業コード"
							></el-input>
						</el-form-item>
						<el-form-item prop="user" label="ユーザーID">
							<el-input
								class="inputClass"
								v-model="LoginForm.user"
								placeholder="ユーザーID"
							></el-input>
						</el-form-item>
						<el-form-item prop="pass" label="パスワード">
							<el-input
								type="password"
								class="inputClass"
								v-on:keyup.enter="openFullScreenLoading"
								v-loading.fullscreen.lock="fullscreenLoading"
								v-model="LoginForm.pass"
								placeholder="パスワード"
							></el-input>
						</el-form-item>
						<div class="checkboxSpan">
							<el-checkbox v-model="checked">ログイン状態を保持する</el-checkbox>
						</div>
						<el-form-item>
							<el-button
								native-type="submit"
								class="btn-click"
								type="primary"
								plain>ログイン</el-button>
						</el-form-item>
						<div class="linkDiv">
							<!--// 2022/07/26  #13298  START -->
							<el-link type="primary" @click="ForgetPassword" :underline="false" class="">パスワードの再設定はこちらから</el-link>
							<!--// 2022/07/26  #13298  END -->
						</div>
						<!--// 2022/07/26  #13298  START -->
						<div class="labelDiv">
							<label>ログインＩＤを皆様で共有されているタイプは、こちらからパスワードの再設定はできません。担当者までお問合せください。 </label>
						</div>
						<!--// 2022/07/26  #13298  END -->
					</el-form>
				</el-main>
			</div>
		</div>
	</el-container>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import Common from "../../common/CommonFunc.js";
import router from "../../router";
import json from '../../common/CommonConst.json';
export default {
	name: "LoginScreen",
	data() {
		var confirmCompanyCodeLength = (rule, value, callback) => {
			var companyCodeCheck = this.LoginForm.contract;
			if (companyCodeCheck.length > 12) {
				callback(new Error("Enter confirm password"));
			} else {
				callback();
			}
		};
		var confirmUserIDLength = (rule, value, callback) => {
			var userIDCheck = this.LoginForm.user;
			if (userIDCheck.length > 256) {
				callback(new Error("Enter confirm password"));
			} else {
				callback();
			}
		};
		var confirmPasswordLength = (rule, value, callback) => {
			var passwordCheck = this.LoginForm.pass;
			if (passwordCheck.length > 256) {
				callback(new Error("Enter confirm password"));
			} else {
				callback();
			}
		};
		return {
			fullscreenLoading: false,
			LoginForm: {
				contract: "",
				user: "",
				pass: ""
			},
			rules: {
				contract: [
					{
						required: true,
						type: "string",
						message: "企業コードを入力してください。"
					},
					{
						validator: confirmCompanyCodeLength,
						message: "企業コードは12文字以下を入力してください。"
					},
					{
						pattern: /^[/a-zA-Z0-9-!#$%^&*()_+|~=`{}[\]:";'<>?,. @]+$/,
						message: "企業コードは半角英数字を入力してください。"
					},
					{
						/*** Change by CK for backlog Id: 1530 removed "/" in the pattern*/
						pattern: /^[\u30ff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9]+$/,
						message: "企業コードは記号を入力できません。"
					}
				],
				user: [
					{
						required: true,
						type: "string",
						message: "ユーザーIDを入力してください。"
					},
					{
						validator: confirmUserIDLength,
						message: "ユーザーIDは256文字以下を入力してください。"
					},
					{
						pattern:/^[/\u30ff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9-!#$%^&*()_+|~=`{}[\]:";'<>?,.@]+$/,
						message: "ユーザーIDは半角英数字を入力してください。"
					}
				],
				pass: [
					{ required: true, message: "パスワードを入力してください。" },
					{
						validator: confirmPasswordLength,
						message: "パスワードは256文字以下を入力してください。"
					},
					{
						pattern:/^[/\u30ff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9-!#$%^&*()_+|~=`{}[\]:";'<>?,.@]+$/,
						message: "パスワードは半角英数字を入力してください。"
					}
				]
			},
			checked: ""
		};
	},
	computed: {
		...mapGetters("situation0001", [
			//error message flag for getting response
			"getErrorMessage",
			"getElAdminAlert",
			"getStatusCode",
			"getMsgDetails",
			"getResponseMessage",
			"getResponseMessageCode",
			"getModeCheck",
			"getModeCheckRequests"
		])
	},
	methods: {
		ForgetPassword() {
			this.$LogButtonEvent("0001","Forgetpassword");
			this.$LogMethodIN("0001","ForgetPassword");
			var credentials = {
				contract_code: this.LoginForm.contract,
				user_id: this.LoginForm.user
			};
			router.push({
				name: "0022",
				params: {
					credentials: credentials
				}
			});
			this.$LogMethodOut("0001","ForgetPassword");
		},
		submitLoginForm(formName) {
      if (this.fullscreenLoading) {
        return
      }
      this.fullscreenLoading = true

			Common.General.SetLocalStorage("ip_authenicate_user", false);

			this.$LogButtonEvent("0001","Login");
			this.$LogMethodIN("0001","submitLoginForm");
			this.$refs[formName].validate(valid => {
				if (valid) {
					var credentials = "";
					if (this.checked == true) {
						credentials = {
							contract_code: this.LoginForm.contract,
							user_id: this.LoginForm.user,
							password: this.LoginForm.pass,
							Remember_me: true
						};
					} else {
						credentials = {
							contract_code: this.LoginForm.contract,
							user_id: this.LoginForm.user,
							password: this.LoginForm.pass,
							Remember_me: false
						};
					}

					Vue.prototype.$session.set("contract_code", this.LoginForm.contract);
					this.$store
						.dispatch("communication0001/login", { credentials })
						.then(() => {
							
							var errorMessage = this.getErrorMessage;							
							if (errorMessage == 0 && this.getResponseMessage !='') {
								this.fullscreenLoading = false;
								this.$alert(this.getResponseMessage, "ログイン", {
									confirmButtonText: "OK"
								});
							}
							if(this.getResponseMessageCode == json['IpFailMsgCode']){
								/*** Change by SJ for backlog Id: 1645 */
								router.push('/0001');
							}
							if(this.getModeCheck != ''){
								var pdfValues = this.getModeCheck
								var pdf_flag = pdfValues.pdf_flag;
								var pdfDisplayRequestLog = this.getModeCheckRequests
								var pdfCombinedArray = [];
								pdfCombinedArray.push(pdfValues)
								pdfCombinedArray.push(pdfDisplayRequestLog)
								if(pdf_flag === 1){
									
									this.$store.dispatch("communication0004/getPdfDisplay", pdfCombinedArray).then(()=> {
										this.fullscreenLoading = false;									

									});
								}else{
									this.$store.dispatch("communication0004/getPdfPrint", pdfCombinedArray).then(()=> {
										this.fullscreenLoading = false;

									});
								}
								
							}
						})
						.catch(error => {
							this.fullscreenLoading = false;
							console.log(error);
						});
				} else {
					this.fullscreenLoading = false;
					return false;
				}
			});
			this.$LogMethodOut("0001","submitForm");
		},
		openFullScreenLoading() {
			if (
				this.LoginForm.contract == "" &&
				this.LoginForm.user == "" &&
				this.LoginForm.pass == ""
			) {
				this.fullscreenLoading = false;
			} else {
				this.fullscreenLoading = true;
			}
		}
	},
	//called after all the DOM elements has been mounted
	mounted() {
		/*** Worked by AJ for backlog Id: 1314 */
		//Code for set the previously entered Company Code value
		var UserContractCode = Common.General.GetLocalStorage('Contract_code');
		
		if(UserContractCode != '' && UserContractCode != null && UserContractCode != undefined)
		{
			this.LoginForm.contract = UserContractCode;
		}
		/*** Worked by AJ for backlog Id: 1314 */
		//Get table Alert Message during page load
		this.$store.dispatch("communication0001/getElAlert");
		//if (this.$route.query.ip == 1) {
		//	this.$store.dispatch("communication0021/IpCheckingResponse");
		//}
	},
	created() {
		//For the screen Title
		document.title = "記事閲覧";
	},
};
</script>
<style scoped>
@import "../../assets/css/style.css";
@import "0001.css";
</style>
